import type { ReactNode } from "react";

export function ErrBox({ children }: { children: ReactNode }) {
  return (
    <div role="alert" style={{
      padding: 12,
      background: "#fee2e2",
      border: "1px solid #fecaca",
      borderRadius: 8,
      color: "#991b1b",
      fontSize: 14,
    }}>{children}</div>
  );
}
